import axios from 'axios'

export default class industryApi {
  static infoAddFeedback(data) {
    return axios.post('/high/info/addFeedback', data)
  }

  static infoDetail(id) {
    return axios.get(`/high/info/detail/${id}`)
  }

  static infoGetExpertList(data) {
    return axios.get('/high/info/getExpertList', { params: data })
  }

  static infoHomeList(data) {
    return axios.get('/high/info/homeList', { params: data })
  }

  static infoMoreList(data) {
    return axios.get('/high/info/moreList', { params: data })
  }

  static infoQueryList(data) {
    return axios.get('/high/info/queryList', { params: data })
  }

  static infoQueryTotal(data) {
    return axios.get('/high/info/queryTotal', { params: data })
  }

  static channelList(data) {
    return axios.get('/high/channelType/getJsonList', { params: data })
  }
}



// WEBPACK FOOTER //
// ./src/api/industryApi.js